

export const EXPANDER_DEFAULT_ICON_SIZE = 15;
export const EXPANDER_DEFAULT_ICON = {
  COLLAPSED: 'chevrondown',
  EXPANDED: 'chevronup'
};
export const EXPANDER_DEFAULT_COLOR = {
  STATIC: 'denim',
  HOVER: 'regent'
};